import { render, staticRenderFns } from "./teacher_record_list.vue?vue&type=template&id=7650eda4&scoped=true"
import script from "./teacher_record_list.vue?vue&type=script&lang=js"
export * from "./teacher_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7650eda4",
  null
  
)

export default component.exports